<template>
  <div>
    <div class="container">
      <div class="reg-header">
        <img src="./../assets/header-3.jpg" alt="" />
      </div>
      <div class="sub-header">
        <div class="cn">设备注册</div>
        <div class="en">Equipment Registration</div>
      </div>
      <div class="main">
        <p>请填写并提交您的设备资料，以便我们为您建立售后服务档案，提供更快速、完善的服务。</p>
        <p class="desc-cn">Please fill in your equipment information so that we can establish an after-sales service file for you and provide quicker and better service.</p>
        <br />
        <div class="form">
          <div class="form-control">
            <label for="">*型号 / Type</label>
            <input type="text" v-model="form.type" />
          </div>
          <div class="form-control">
            <label for="">*产品系列号 / Serial No.</label>
            <textarea v-model="form.serial_no"></textarea>
          </div>
          <p><strong>或上传产品铭牌照片</strong></p>
          <p class="upload-desc">Or upload the picture of your equipment nameplate.</p>
          <van-uploader :before-delete="delImgs" :after-read="uploadImgs" v-model="filelist" upload-text="点击上传" :max-count="5"> </van-uploader>
          <div class="form-control">
            <label for="">*联系人 / Contact</label>
            <input type="text" v-model="form.contact" />
          </div>
          <div class="form-control">
            <label for="">*公司名称/ Company</label>
            <input type="text" v-model="form.company" />
          </div>
          <div class="form-control">
            <label for="">*联系电话/ Tel</label>
            <input type="text" v-model="form.telephone" />
          </div>
          <div class="form-control">
            <label for="">*公司类型/ Company Type</label>
            <select v-model="form.company_type">
              <option :value="type" v-for="(type, idx) in companyTypes" :key="idx">
                {{ type }}
              </option>
            </select>
          </div>
          <div class="form-control">
            <label for="">*产品类型/ Product Type</label>
            <select v-model="form.product_type">
              <option :value="type" v-for="(type, idx) in productTypes" :key="idx">
                {{ type }}
              </option>
            </select>
          </div>
          <div class="form-control">
            <label for="">其它 / Other Requirements</label>
            <textarea v-model="form.requirements"></textarea>
          </div>
          <div class="button">
            <button @click="submit()">提交 Submit</button>
          </div>
        </div>
      </div>
      <div class="reg-footer">
        <p>联系我们 Contact Us</p>
        <p>
          <img src="../assets/phone-call.png" alt="" class="phonecall" />
          4001-528-008
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { uploadImg, deviceRegistration } from "./../api/request";

const companyTypes = ["最终用户 End user", "系统集成商 System Integrator", "OEM或经销商 Distributor"];
const productTypes = [
  "工业搅拌机 Industrial Mixer",
  "换热器Heat Exchanger",
  // "液压工具 Hydraulic Tool",
  // "干燥及过滤机 Dehydration/Filtration Product",
  "布朗卢比泵 Bran+Luebbe Pump",
  "庄森泵 Johnson Pump",
  "卫生级设备 Sanitary Products",
];
export default {
  data() {
    return {
      index: 0,
      filelist: [],
      form: {
        company_type: companyTypes[0],
        product_type: productTypes[0],
      },
      companyTypes,
      productTypes,
    };
  },
  methods: {
    async submit() {
      console.log(this.form);
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });

      try {
        await deviceRegistration(this.form);
        Toast("提交成功!");
        setTimeout(() => {
          if (window.WeixinJSBridge) {
            window.WeixinJSBridge.call("closeWindow");
          } else if (window.AlipayJSBridge) {
            window.AlipayJSBridge.call("closeWebview");
          } else {
            window.close();
          }

          history.back();
        }, 1000);
      } catch (error) {
        Toast({
          message: error.data.msg,
        });
      }
    },
    delImgs() {},
    async uploadImgs(file) {
      let that = this;
      if (file.length) {
        file.forEach(async (f) => {
          let img = await uploadImg(f.file);
          if (that.form.files == null) {
            that.form.files = [];
          }
          let form = JSON.parse(JSON.stringify(that.form));
          form.files.push(img.data.url);
          that.form = form;

          Toast("图片上传成功!");
        });
      } else {
        let img = await uploadImg(file.file);
        // eslint-disable-next-line no-debugger
        // debugger;
        if (that.form.files == null) {
          that.form.files = [];
        }
        let form = JSON.parse(JSON.stringify(that.form));
        form.files.push(img.data.url);
        that.form = form;

        Toast("图片上传成功!");
      }
    },
    async load() {},
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 191px);
  background-color: #d3cccc;
  .reg-header {
    border-bottom: 1px solid #fff;
    img {
      display: block;
      width: 100vw;
    }
  }
  .sub-header {
    background-color: #407cca;
    color: #fff;
    padding: 10px;
    .cn {
      font-weight: 700;
      font-size: 17px;
    }
    .en {
      font-size: 12px;
    }
  }
  .main {
    padding: 25px;
    color: #bdbdbd;
    .desc-cn {
      margin-top: 10px;
    }
    .upload-desc {
      margin-bottom: 10px;
    }
    .form-control {
      margin-bottom: 10px;
      label {
        color: #407cca;
        font-weight: 700;
        font-size: 13px;
        display: block;
        height: 30px;
        line-height: 30px;
      }
      input[type="text"],
      textarea,
      select {
        width: 100%;
        border-radius: 3px;
        border: 1px solid #bdbdbd;
        padding: 0 8px;
        box-sizing: border-box;
        font-size: 12px;
        color: #333;
      }
      input[type="text"],
      select {
        height: 30px;
      }
      textarea {
        padding: 8px;
      }
    }
    .button {
      text-align: right;
      button {
        height: 40px;
        width: 116px;
        background: #407cca;
        color: #fff;
        border-radius: 3px;
        border: none;
        font-size: 13px;
        font-weight: 700;
      }
    }
    h3 {
      font-size: 18px;
    }
    h4 {
      font-size: 18px;
      margin-bottom: 30px;
    }
    p {
      font-size: 13.5px;
      color: #407cca;
      strong {
        font-weight: 700;
      }
    }
  }
  .reg-footer {
    // background-color: #407cca;
    font-weight: 400;
    color: #ededed;
    line-height: 36px;
    text-align: center;
    padding: 10px;
    font-size: 13.5px;
  }
  .phonecall {
    width: 12.5px;
    position: relative;
    top: 1px;
    margin-right: 5px;
  }
}
</style>
